import { render } from "./social-feed.vue?vue&type=template&id=2b4f7ad6"
import script from "./social-feed.vue?vue&type=script&lang=js"
export * from "./social-feed.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__